let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class MenuToggleController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;

  }

  $onInit() {

  }

}

MenuToggleController.$inject = inject;

export default MenuToggleController;




// WEBPACK FOOTER //
// ./www/components/shared/components/menu-toggle/menu-toggle.controller.js